import styles from './UspCard.module.scss';
import { UI_Heading } from 'ui/components/1-atoms/Heading/Heading';
import { UI_Link } from 'ui/components/1-atoms/Action/Link/Link';
import { UI_Picture } from 'ui/components/1-atoms/Media/Picture/Picture';
import ArrowRight from 'ui/icons/Arrow-Right.svg';
import { UI_Icon } from 'ui/components/1-atoms/Media/Icon/Icon';
import { UI_Paragraph } from 'ui/components/1-atoms/Paragraph/Paragraph';

export interface UspCardProps {
	className?: string;
	image: {
		url: string;
		focalPoint?: { left: number; top: number };
		extension?: string;
		altText?: string;
	};
	number: number;
	title: string;
	description: string;
	link: {
		url: string;
		target?: string;
		name?: string;
	};
}

export const UI_UspCard = ({ image, number, title, description, link }: UspCardProps) => {
	return (
		<div className={styles.UspCard}>
			<UI_Link className={styles.UspCard_link} title={link?.name} {...link} style="primary">
				{image && (
					<div className={styles.UspCard_media}>
						{image?.url ? (
							<span className={styles.UspCard_mediabox}>
								<UI_Picture
									imageRatio={0.5625}
									url={image.url}
									altText={image.altText}
									focalPoint={image.focalPoint}
									sizes="(max-width: 768px) 100vw, (min-width: 769px) 33vw"
								/>
							</span>
						) : (
							<div className={styles.UspCard_placeholder} />
						)}
					</div>
				)}
				<div className={styles.UspCard_textbox}>
					<div className={styles.UspCard_textbox__content}>
						<span className={styles.UspCard_headingNumber}>{number}.</span>
						<UI_Heading className={styles.UspCard_heading} headingLevel="h3" style="sm">
							{title}
						</UI_Heading>
						<UI_Paragraph className={styles.UspCard_paragraph}>{description}</UI_Paragraph>
					</div>

					<UI_Icon size="xl" style="secondary" type="circle" className={styles.UspCard_icon}>
						<ArrowRight />
					</UI_Icon>
				</div>
			</UI_Link>
		</div>
	);
};
